/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Download",
  size: 20
}

const SvgDownload = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path fill="none" d="M14 10l-4.5 4.5L5 10" />
    <path d="M3 17h13v1H3z" />
    <path fill="none" d="M9.5 13.91V3" />
  </Svg>
)

SvgDownload.defaultProps = defaultProps
export default SvgDownload
